import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
Vue.use(VueRouter)

function guard(to, from, next){
  if((localStorage.getItem('user') !== null)) {
    next('/'); // allow to enter route
  } else {
    next(); // go to '/login';
  }
}

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/events/:id',
    name: 'Events',
    component: () => import(/* webpackChunkName: "events" */ '../views/Events.vue'),
  },
  {
    path: '/infos/:id',
    name: 'Infos',
    component: () => import(/* webpackChunkName: "infos" */ '../views/Infos.vue'),
  },
  {
    path: '/checkin',
    name: 'Einchecken',
    component: () => import(/* webpackChunkName: "checking" */ '../views/Checkin.vue')
  },
  {
    path: '/impressum',
    name: 'Imprint',
    component: () => import(/* webpackChunkName: "impressum" */ '../views/Imprint.vue')
  },
  {
    path: '/payment-result',
    name: 'PaymentResult',
    component: () => import(/* webpackChunkName: "payment-result" */ '../views/PaymentResult.vue')
  },
  {
    path: '/datenschutz',
    name: 'DataProtection',
    component: () => import(/* webpackChunkName: "datenschutz" */ '../views/DataProtection.vue')
  },
  {
    path: '/agb',
    name: 'TermsAndCondition',
    component: () => import(/* webpackChunkName: "agb" */ '../views/TermsAndCondition.vue')
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery.vue')
  },
  {
    path: '/profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/',
        name: 'Profile.account',
        component: () => import(/* webpackChunkName: "account" */ '../views/Account.vue'),
      },
      {
        path: 'my-events',
        name: 'Profile.my-events',
        component: () => import(/* webpackChunkName: "my-events" */ '../views/MyEvents.vue'),
      }
    ]
  },
  {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
      beforeEnter: guard
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
    beforeEnter: guard
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "forgot-password" */ '../views/ForgotPassword.vue'),
    beforeEnter: guard
  },
    {
      path: '/change-password',
      name: 'ChangePassword',
      component: () => import(/* webpackChunkName: "change-password" */ '../views/ChangePassword.vue'),
    },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "error" */ '../views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
